import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PlanSelectionPage from './pages/PlanSelectionPage';
import DomainSelectionPage from './pages/DomainSelectionPage';
import CheckoutPage from './pages/CheckoutPage';
import SuccessPage from './pages/SuccessPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CancelSubscriptionPage from './pages/CancelSubscriptionPage';
import DowngradeSubscriptionPage from './pages/DowngradeSubscriptionPage';
import RetryPaymentPage from './pages/RetryPaymentPage';
import UpdatePaymentMethodPage from './pages/UpdatePaymentMethodPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminPage from './pages/AdminPage';
import SubscriptionsPage from './pages/SubscriptionsPage';
import AppsPage from './pages/AppsPage';
import AccessDetailsPage from './pages/AccessDetailsPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AffiliatePage from './pages/AffiliatePage';
import WhatsAppSupport from './components/WhatsAppSupport';
import { captureAttribution } from './utils/attribution';
import './App.css';

function App() {
  // Capture affiliate referral code + marketing attribution (UTM) on any page load
  if (typeof window !== 'undefined') {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) localStorage.setItem('openhosst_ref', ref);
    captureAttribution();
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        {/* Dynamic service routes - :service can be n8n, wordpress, ghost, openclaw, etc. */}
        <Route path="/subscriptions/:subscriptionId/access" element={<AccessDetailsPage />} />
        <Route path="/:service" element={<PlanSelectionPage />} />
        <Route path="/:service/verify-email" element={<VerifyEmailPage />} />
        <Route path="/:service/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/:service/reset-password" element={<ResetPasswordPage />} />
        <Route path="/:service/cancel-subscription" element={<CancelSubscriptionPage />} />
        <Route path="/:service/downgrade-subscription" element={<DowngradeSubscriptionPage />} />
        <Route path="/:service/retry-payment" element={<RetryPaymentPage />} />
        <Route path="/update-payment-method" element={<UpdatePaymentMethodPage />} />
        <Route path="/domain/:planSlug" element={<DomainSelectionPage />} />
        <Route path="/checkout/:planSlug" element={<CheckoutPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/affiliate" element={<AffiliatePage />} />
        {process.env.REACT_APP_BUILD_TARGET === 'admin' && <Route path="/admin" element={<AdminPage />} />}
        <Route path="/apps" element={<AppsPage />} />
        <Route path="/subscriptions" element={<SubscriptionsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <WhatsAppSupport />
    </Router>
  );
}

export default App;
